import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter, OnDestroy  } from '@angular/core';
import { HostListener } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { Router } from "@angular/router";
import { WorkflowsService } from '@app/services/settings/workflows.service';
import { SettingsWorkflowsService } from '@app/services/settings/sworkflows.service';

import { Workflow, WorkflowTransition } from '@core/objects/workflow';
// import { Status } from '@core/objects/status';
// import { RequestStatus, RequestStatusWithInitial } from '@core/objects/request-status';

// import { WorkflowEditor, WorkflowEditorData } from '../workflow-editor';
import { WorkflowEditor, WorkflowEditorData } from './editor';

@Component({
    selector: 'settings-workflows-workflow-editor',
    templateUrl: './editor.component.html',
    styleUrls: ['./editor.component.scss']
})
export class SettingsWorkflowsWorkflowEditorComponent implements OnInit, OnChanges, OnDestroy {

	public readonly STATUS_LOADING = 0;
	public readonly STATUS_DONE = 1;
    public readonly STATUS_ERROR = 2; // general error 500
    public readonly STATUS_NOT_FOUND = 3; // wf or url dont exists
    public readonly STATUS_NOT_ALLOWED = 4; // wf not in org or not permission
    public readonly STATUS_DATA_ERROR = 5; // bad payload

    @Input() workflow: Workflow;
    // @Input() stages: Array<Status>;
    // @Input() saved: Observable<void>;
    // @Output() submit:EventEmitter<any> = new EventEmitter<any>();

    public pageStatus: Number = this.STATUS_LOADING;
    public saveActionStatus: Number = this.STATUS_DONE;
    public saving: boolean = false;
    // public editor: any;

    public ready: boolean =  false;
    // protected projectStages: Array<any> = [];
    // private savedSubscription: Subscription;
    private transitionsSubscription: Subscription;
    private workflowsInitializedSubscriptor: Subscription;
    private errorSubscriptor: Subscription;
    // --
    private editorConfig: any = {
        width: 600,
        height: 400,
        target: "figure#workflow-editor-area"
    };

    // private e: WorkflowEditor
    // private data: WorkflowEditorData;
    private e: any;
    public data: WorkflowEditorData = null;

    private output:EventEmitter<any> = new EventEmitter<any>();
    public valid: boolean = false;
    protected editing: boolean = false;


	constructor(private workflowsSrv: WorkflowsService, 
        private sworkflowsSrv: SettingsWorkflowsService,
        private router: Router){}

	ngOnInit(){
        // this.savedSubscription = this.saved.subscribe(() => this.hideSaveButton());

		this.transitionsSubscription =  this.sworkflowsSrv.selectTransitions().subscribe((transitions: Array<WorkflowTransition>) => {
            this.data = new WorkflowEditorData(this.workflow, transitions);
            this.initEditor(this.data);
            this.pageStatus = this.STATUS_DONE;
            this.saving = false;
        });

        this.workflowsInitializedSubscriptor = this.sworkflowsSrv.selectInitialized().subscribe((initialized: any) => {
            this.ready = initialized.editor;
        });

        this.output.subscribe((data) => {
            console.debug("this.output sucriber ---> on init: ",data);

            this.receiveData(data);
        });

        this.errorSubscriptor = this.sworkflowsSrv.selectError('set_workflow_transitions')
            .subscribe((error: HttpErrorResponse) => this.setError(error));

	}

    ngOnChanges(changes: SimpleChanges) {
        if(changes.workflow && changes.workflow.currentValue != null)
            this.init();
    }

    ngOnDestroy(): void {
        this.transitionsSubscription.unsubscribe();
        this.workflowsInitializedSubscriptor.unsubscribe();
    }

    @HostListener('window:beforeunload', ['$event'])
    onWindowClose(event: any): void {

        if(this.editing) {
            event.preventDefault();
            event.returnValue = false;
        }
    }

    init(){
        this.sworkflowsSrv.loadWorkflowTransitions(this.workflow.id);
        this.editing = false;
    }


    protected initEditor(data: WorkflowEditorData) {
        // TODO set width of page area in editor config

        // this.e = new WorkflowEditor(this.editorConfig, data);

        this.e = new WorkflowEditor({
            target: "figure#workflow-editor-area",
            width: 1130,
            height: 1000,
            update: this.output
        }, data.status, data.transitions);
    }

    receiveData(event: any) {
        this.editing = true;
        this.data.setOutput(event);
        this.valid = this.data.isOutputValid();
    }

    save() {
        this.saving = true;
        this.sworkflowsSrv.saveWorkflowTransitions(this.data.output,this.workflow.id);
        this.data.resetOutput();
        this.editing = false;
        this.valid = this.data.isOutputValid();

        // old way, after 10/11/2023 action is through the workflows store.
        // this.workflowsSrv.updateWorkflowTransitions$(this.data.output,this.workflow.id).subscribe((wf: any) => {
        //     //don't reload editor after save.
        //     this.data.resetOutput();
        //     this.editing = false;
        //     this.valid = this.data.isOutputValid();
        // });


    }

    cancel() {
        this.editing = false;
        this.data.resetOutput();
        this.valid = this.data.isOutputValid();
        this.router.navigate(['/settings/workflows']);
    }
    // protected loadEditor(data: WorkflowEditorData){
    //     this.editor = null;
    //     this.editor = new workflowEditor({
    //         target: "#settings-workflow-editor-area",
    //         width: 1130,
    //         height: 1000,
    //         save: this.saveWorkflow
    //     }, data);
    // }


    // the old way seems not work with the jquery of the twona-workflow-editor.js.
//     saveWorkflow = (event: any) => {
//         if (event.hasOwnProperty('initial_status')){
//             console.log("save here: ", event);
//             // this.submit.emit(event);
//         } else {
//             console.error("NO INITIAL STATUS SET ");

// // TODO notify to set initial status with some message!
//         }
//     }

    // listener of action save transitions done and saved
    protected hideSaveButton() {
        console.debug("saved done, hide button in editor");
        // this.editor.hiddeSaveButton();
    }

    // cleanForm(){
	// 	this.form.reset({name: ''});
	// }

    protected setError(error: HttpErrorResponse) {
        if(error == null){ //201
            this.saveActionStatus = this.STATUS_DONE; // reload by the store effects
            return;
        }

        switch(error.status) {
            case 500:
                this.saveActionStatus = this.STATUS_ERROR;
                break;
            case 406:
                this.saveActionStatus = this.STATUS_DATA_ERROR;
                break;
            case 404:
                this.saveActionStatus = this.STATUS_NOT_FOUND;
                break;
            case 403:
                this.saveActionStatus = this.STATUS_NOT_ALLOWED;
                break;
        }
    }

    dismiss(){
        this.saveActionStatus = this.STATUS_DONE;
    }

    showWorkflowsList(){
        this.router.navigate(['/settings/workflows']);
    }
}
